// Application routes configuration

import type { Routes } from '@/types';

const routes: Routes = {
  home: '/',
  help: '/help',
  helpDetail: '/help/:section',
  helpGettingStarted: '/help/getting-started',
  helpAuthentication: '/help/authentication',
  helpFiles: '/help/files',
  helpDatasets: '/help/datasets',
  helpMap: '/help/map',
  helpTools: '/help/tools',
  helpAccessibility: '/help/accessibility',
  helpReports: '/help/reports',
  helpDataLineage: '/help/data-lineage',
  helpDataCatalog: '/help/data-catalog',
  helpTpsMapping: '/help/tps-mapping',
  helpDefinitions: '/help/definitions',
  helpDereferencing: '/help/dereferencing',
  helpSupport: '/help/support',
  files: '/files',
  datasets: '/datasets',
  map: '/map',
  tpsMapping: '/map/tps-mapping',
  tools: '/tools',
  search: '/search',
  admin: '/admin',
  login: '/login',
  accessDenied: '/access-denied',
  forbidden: '/403',
  data: '/data/*',
  ontology: '/ontology/*',
  dereference: '/dereference',
  keyFigures: '/key-figures',
  swagger: '/swagger',
  reports: '/reports',
  statusReports: '/reports/status',
  statusReportDetail: '/reports/status/:period',
  catalog: '/catalog',
  catalogDataset: '/catalog/:dataset',
  rinfStatus: '/reports/rinf',
  railmlStatus: '/reports/railml',
  // Served by its own app, so links to it load the page
  dataQualityPortal: '/data-quality/',
  dataTreehouseValidation: '/validation/',
};

export default routes;
